import { TOKEN_KEY, USER_KEY } from "@/data/constData";
import Repository from "@/repository/Repository";
import { Factory } from "@/repository/Factory";
const User = Factory.get("user");
import { PATH_HOME } from "@/data/pathData";
import router from "../router";
import mixins from "@/mixins/global";

// import mixins from "@/mixins/global";
// import router from "../../router";

const state = {
  user: null,
  authUser: JSON.parse(localStorage.getItem(USER_KEY)),
  //  accessToken: localStorage.getItem(TOKEN_KEY),
  accessToken: null
};

const getters = {
  getUser(state) {
    return state.user;
  },
  authUser: state => state.authUser,
  isLoggedIn: state => (state.accessToken ? true : false),
  accessToken: state => state.accessToken
};

const mutations = {
  setToken: (state, payload) => {
    const tokens = {
      access_token: payload.access_token,
      refresh_token: payload.refresh_token,
      role: payload.user && payload.user.role,
      user: payload.user
    };

    Repository.defaults.headers.Authorization = `Bearer ${payload.access_token}`;
    localStorage.setItem(process.env.VUE_APP_USER, JSON.stringify(tokens));
  },
  setUser(state, user) {
    state.user = JSON.parse(JSON.stringify(user));
  },
  LOGIN: (state, payload) => {
    const { token, role } = payload;
    //localStorage.setItem(TOKEN_KEY, token);
    state.accessToken = token;
    state.currentUser = role;
  },
  LOGOUT: state => {
    state.currentUser = null;
    localStorage.removeItem(TOKEN_KEY);
    state.accessToken = null;
  },
  SET_USER: (state, payload) => {
    state.authUser = payload;
    localStorage.setItem(USER_KEY, JSON.stringify(payload));
  },
  DESTROY_USER: state => {
    state.authUser = null;
    state.accessToken = null;
    localStorage.removeItem(USER_KEY);
  },
  SET_TOKEN: (state, payload) => {
    state.accessToken = payload;
  }
};

const actions = {
  async loginUser({ commit }, payload) {
    return await User.loginUser(payload).then(
      async response => {
        if (
          response.status === 200 &&
          response.data.code === "user/login/email/success"
        ) {
          commit("setToken", response.data);

          commit(
            "setToast",
            {
              message: response.data.message,
              type: "success",
              show: true
            },
            { root: true }
          );
        }

        return Promise.resolve(response.data);
      },
      error => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        commit(
          "setToast",
          {
            message: message,
            type: "error",
            show: true
          },
          { root: true }
        );

        return Promise.reject(message);
      }
    );
  },

  // Get Logged User
  async getLoggedUser({ commit }) {
    return await User.getLoggedUser().then(
      async response => {
        if (response.status === 200) {
          commit("setUser", response.data);
        }

        return Promise.resolve(response.data);
      },
      error => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        commit(
          "setToast",
          {
            message: message,
            type: "error",
            show: true
          },
          { root: true }
        );

        return Promise.reject(message);
      }
    );
  },

  // Refresh Token
  async refreshToken({ commit, dispatch }) {
    try {
      const resp = await User.refreshToken();

      if (resp && resp.status === 200) {
        console.log(resp);
        if (resp && resp.data) {
          commit("setToken", resp.data);
          const user = await dispatch("getLoggedUser");

          const data = {
            user,
            ...resp.data
          };

          console.log("Data", data);

          commit("setToken", data);
          router.push(PATH_HOME);

          // if (!payload || !payload.id) {
          //   if (user && user.type === 'owner') {
          //     router.push('/projects').catch(() => {})
          //   }
          //   if (user && user.type === 'sub-user') {
          //     router.push('/owners').catch(() => {})
          //   }
          //   if (user && user.type === 'teo-admin') {
          //     router.push('/dashboard/analytics').catch(() => {})
          //   }
          // }
        }

        return Promise.resolve(resp);
      }
    } catch (err) {
      commit(
        "setToast",
        {
          message:
            err.response && err.response.data.message
              ? err.response.data.message
              : "Session Expired. Please Login again.",
          color: "red",
          show: true
        },
        { root: true }
      );

      if (
        err.response &&
        err.response.status === 400 &&
        err.response.data.error_code === "user/refresh_token/no-cookie"
      ) {
        mixins.methods.logoutUser();
      }
      return Promise.reject(err);
    }
  },

  // Logout User
  async logoutUser() {
    return await User.logoutUser().then(
      async response => {
        if (response.status === 200) {
          return Promise.resolve(response);
        }

        return Promise.reject(response);
      },
      error => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        return Promise.reject(message);
      }
    );
  },

  login: ({ commit }, payload) => {
    commit("LOGIN", payload);
  },
  logout: ({ commit }) => {
    commit("LOGOUT");
  },
  setUser: ({ commit }, payload) => {
    commit("SET_USER", payload);
  },
  setToken: ({ commit }, payload) => {
    commit("SET_TOKEN", payload);
  },
  destroyUser: ({ commit }) => {
    commit("DESTROY_USER");
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
